import useCarIntegration from "$src/core/hooks/use-car-integration";

/**
 * Root-level glue for CarPlay / Android Auto; renders nothing. Playback stays
 * native because a cold in-car launch runs without the React tree.
 * Mount only when `isCarIntegrationSupported`.
 */
const CarIntegration = () => {
  useCarIntegration();

  return null;
};

export default CarIntegration;
